import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'How do I contact support?',
    answer: 'You can reach us by email at Benjobalolong082@gmail.com or by phone on 0800 055 4969. Our office hours are Monday to Friday, 9:00am–5:00pm, and Saturday, 9:00am–1:00pm.'
  }, {
    question: 'When does my service begin and end?',
    answer: 'Your service starts once payment is confirmed and runs for the chosen term (e.g., 12 months) from that date. You will receive a confirmation email with all the details.'
  }, {
    question: 'How do I book a repair?',
    answer: 'Simply email or call us. We normally schedule engineer visits within 24–48 hours of your initial contact.'
  }, {
    question: 'What appliances do you handle?',
    answer: 'We service most household appliances, including washing machines, tumble dryers, dishwashers, cookers, fridges and TVs (subject to age and condition).'
  }, {
    question: 'How fast can you attend?',
    answer: 'We respond within 48 hours to arrange a visit. During busy periods or in remote areas, it may take slightly longer.'
  }, {
    question: 'What about refunds and cancellations?',
    answer: 'You may cancel within 14 days for a full refund (if no work has been carried out). Cancellations between days 15–28 may qualify for a partial refund at our discretion. After 28 days, refunds are not available.'
  }, {
    question: 'What if I have a dispute?',
    answer: 'Please contact us first so we can resolve things quickly. This approach helps avoid delays and ensures we can address your concerns properly.'
  }];
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-403">
      <Header data-id="element-404" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-405">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-406">
          <h1 className="text-5xl font-bold mb-6" data-id="element-407">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-408">
            Find answers to common questions about our repair services
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-409">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-411">
            <div className="space-y-4" data-id="element-412">
              {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-lg overflow-hidden" data-id="element-413">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-50 transition-colors" data-id="element-414">
                    <span className="text-lg font-semibold text-slate-800 pr-4" data-id="element-415">
                      {faq.question}
                    </span>
                    {openIndex === index ? <ChevronUp className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-416" /> : <ChevronDown className="w-5 h-5 text-teal-600 flex-shrink-0" data-id="element-417" />}
                  </button>
                  {openIndex === index && <div className="px-6 pb-6" data-id="element-418">
                      <p className="text-slate-600 leading-relaxed" data-id="element-419">
                        {faq.answer}
                      </p>
                    </div>}
                </div>)}
            </div>
            <div className="mt-12 p-6 bg-teal-50 rounded-lg" data-id="element-420">
              <h3 className="text-xl font-semibold text-slate-800 mb-3" data-id="element-421">
                Still have questions?
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-422">
                If you can't find the answer you're looking for, please don't
                hesitate to get in touch with our friendly team.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-423">
                <a href="tel:08000554969" className="bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors text-center font-semibold" data-id="element-424">
                  Call 0800 055 4969
                </a>
                <a href="mailto:Benjobalolong082@gmail.com" className="bg-white text-teal-600 border-2 border-teal-600 px-6 py-3 rounded-lg hover:bg-teal-50 transition-colors text-center font-semibold" data-id="element-425">
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-426" />
    </div>;
};